import { z } from 'zod'
import { updateInvoiceCategoriesSchema } from '@/features/invoices/schemas'
import { validateResponseIsOk } from '@/shared/api/validation'
import { createAssetManagementClient } from '@/shared/api/client'

const client = createAssetManagementClient()

export const updateInvoiceCategories = (invoiceId: number, categories: z.infer<typeof updateInvoiceCategoriesSchema>) =>
  validateResponseIsOk(
    client.sendPatch(
      `invoices/${invoiceId}/categories`,
      { data: updateInvoiceCategoriesSchema.parse(categories) }
    )
  ).then(
    () => { }
  )
